import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { extendedMutationType } from '../../types';
import ToggleMutationButton from './ToggleMutationButton';

ActivationButton.propTypes = {
    extendedMutation: extendedMutationType.isRequired,
    confirmationMessage: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
};

function ActivationButton(props) {
    const {
        extendedMutation,
        confirmationMessage,
        isActive,
        disabled = false,
    } = props;
    const { t } = useTranslation();
    return (
        <ToggleMutationButton
            className="activation-button button-bordered-orange"
            confirmationMessage={confirmationMessage}
            extendedMutation={extendedMutation}
            showConfirmationDialog
            icon="power-off"
            toggleFlag={isActive}
            trueFlagText={t('button.deactivate')}
            falseFlagText={t('button.activate')}
            disabled={disabled}
        />
    );
}

export default ActivationButton;
